import { useTranslation } from "react-i18next";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { SectionEyebrow } from "./SectionEyebrow";

const TEXTURE_IMG = "/clinic-reception.jpg";

export const ProblemSolution = () => {
  const { t } = useTranslation();
  const { ref, inView } = useScrollReveal();
  const stats = t("stats", { returnObjects: true });

  return (
    <section data-testid="problem-solution-section" className="py-24 lg:py-36 bg-[#F6F5F2]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div ref={ref} className={`lg:col-span-7 reveal ${inView ? "in-view" : ""}`}>
          <SectionEyebrow num="02">{t("about.eyebrow")}</SectionEyebrow>
          <h2 data-testid="problem-headline" className="font-serif text-4xl lg:text-5xl xl:text-6xl font-light tracking-tight leading-[1.05] text-[#3E5239]">
            {t("about.title_l1")}
            <br />
            <span className="italic text-[#A7CA99]">{t("about.title_l2")}</span>
          </h2>

          <div className="mt-10 space-y-6 max-w-xl text-[#6B7A66] font-light leading-relaxed">
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
          </div>

          <div className="mt-12 grid grid-cols-3 border-t border-[#E4E2DA]">
            {stats.map((it, i) => (
              <div key={it.v} data-testid={`stat-${i}`} className={`py-6 ${i < 2 ? "border-r border-[#E4E2DA]" : ""} pr-4`}>
                <div className="font-serif text-3xl lg:text-4xl font-light text-[#3E5239]">{it.k}</div>
                <div className="overline mt-2">{it.v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden bg-[#EFEDE6]">
            <img src={TEXTURE_IMG} alt="Recepção da Clínica Kosmedico Zürich" data-testid="problem-image" className="w-full h-full object-cover transition-transform duration-[1400ms] hover:scale-[1.04]" />
          </div>
        </div>
      </div>
    </section>
  );
};
